export default __webpack_public_path__ + "static/media/chair-pink.9d3f7659.jpg";